module.exports = __webpack_public_path__ + "ui-static/img/cluster-wizard-fallback_dark.5010ffb4.svg";